import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit"
export default class extends Controller {
  connect() {
    this.timeout = null
  }

  submit() {
    // Clear any existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Set a new timeout to submit after user stops typing
    this.timeout = setTimeout(() => {
      const form = this.element.closest('form')
      if (form) {
        form.requestSubmit()
      }
    }, 500) // Wait 500ms after user stops typing
  }

  submitImmediately() {
    // For select dropdowns, submit immediately
    const form = this.element.closest('form')
    if (form) {
      form.requestSubmit()
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}
